import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../utils/cn';
const COLOR_CLASS = {
    default: undefined,
    coral: 'sec-chip--coral',
    success: 'sec-chip--success',
    warning: 'sec-chip--warning',
    error: 'sec-chip--error',
    info: 'sec-chip--info',
};
/** Kompaktes Status-/Tag-Label (MUI-`Chip`-Ersatz) auf `.sec-chip`-Basis. */
export const Chip = forwardRef(function Chip({ color = 'default', label, className, children, ...rest }, ref) {
    return (_jsx("span", { ref: ref, className: cn('sec-chip', COLOR_CLASS[color], className), ...rest, children: label ?? children }));
});
